import 'jquery-ui-dist/jquery-ui.min.js'
import '@fancyapps/fancybox';
import 'jquery-ui-touch-punch/jquery.ui.touch-punch';

const foodCheck = {};

(function (foodCheckApp) {

    const pages = {
        ageSelection : "ageSelection",
        weightSelection: "weightSelection",
        healthOptions: "healthOptions",
        proteinPreferences: "proteinPreferences",
        results: "results"
    };

    const foodcheckSliderAmountMap = [5, 10, 15, 20, 25, 30, 40, 50, 60];

    let currentPage = pages.ageSelection;
    let bhFoodCheckSelector = {
        name: "",
        year: 0,
        month: 0,
        weight: 5,
        healthOption: 0,
        proteinPreference: 0
    };

    $(document).ready(function () {
        const footer = $(".footer");
        const breadcrumbs = $(".breadcrumbs");
        $("[data-fancybox]").fancybox();
        footer.hide();
        breadcrumbs.hide();

        function reInitializeAgeSelectionPage(){
            $("#pet-name").val(bhFoodCheckSelector.name);
            $("#pet-year").val(bhFoodCheckSelector.year);
            $("#pet-month").val(bhFoodCheckSelector.month);
        }

        function getResultsPage(){
            $.ajax({
                url: "/umbraco/surface/BHFoodCheckSelectorSurface/GetResultsPage",
                type: "GET",
                data: { ...bhFoodCheckSelector, documentId: $("#documentId").val()},
                dataType: "html",
                success: function (data) {
                    $(".quiz").hide();
                    $(".js-quiz-results-render").show();
                    $(".js-quiz-results-render").html(data);
                    changeQuizBottomPanel(pages.results);
                },
                error: function (xhr, status, error) {
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                }
            });
        }

        function getWeightSelectionPage(){
            $.ajax({
                url: "/umbraco/surface/BHFoodCheckSelectorSurface/GetWeightSelection",
                type: "GET",
                data: {},
                dataType: "html",
                success: function (data) {
                    $(".selected-form").html(data);
                    changeQuizBottomPanel(pages.weightSelection);

                    const months = bhFoodCheckSelector.year * 12 + bhFoodCheckSelector.month;

                    if(months <= 8)
                    {
                        $('#pet-name').html(`What is ${bhFoodCheckSelector.name}'s expected adult weight?`);
                    }else if(months >=9){

                        $('#pet-name').html(`What is ${bhFoodCheckSelector.name}'s approximate weight?`);
                    }


                    initializeWeightSlider();
                },
                error: function (xhr, status, error) {
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                }
            });
        }
        function getAgeSelectionPage(){
            $.ajax({
                url: "/umbraco/surface/BHFoodCheckSelectorSurface/GetAgeSelection",
                type: "GET",
                data: {
                    BhFoodCheckSelectorId: $("#documentId").val()
                },
                dataType: "html",
                success: function (data) {
                    $(".selected-form").html(data);
                    changeQuizBottomPanel(pages.ageSelection);
                    reInitializeAgeSelectionPage();
                    formIsValid();
                },
                error: function (xhr, status, error) {
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                }
            });
        }
        function getProteinPreferencesPage() {
            $.ajax({
                url: "/umbraco/surface/BHFoodCheckSelectorSurface/GetProteinPreferencesOptions",
                type: "GET",
                data: {
                    Name: bhFoodCheckSelector.name,
                    FoodCheckSelectorId: $("#documentId").val(),
                    Year: bhFoodCheckSelector.year,
                    Month: bhFoodCheckSelector.month,
                    Weight: bhFoodCheckSelector.weight,
                    HealthOptionId: bhFoodCheckSelector.healthOption
                },
                dataType: "html",
                success: function (data) {
                    if(!data.includes('quiz-results-header')){
                        $(".js-quiz-results-render").hide();
                        $(".quiz").show();
                        $(".selected-form").html(data);
                        changeQuizBottomPanel(pages.proteinPreferences);
                        initializeProteinPreferencesPage();
                    }else{
                        $(".quiz").hide();
                        $(".js-quiz-results-render").show();
                        $(".js-quiz-results-render").html(data);
                        changeQuizBottomPanel("results");
                    }
                },
                error: function (xhr, status, error) {
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                }
            });

        }

        function getHealthOptionsPage(isBack = false){
            $.ajax({
                url: "/umbraco/surface/BHFoodCheckSelectorSurface/GetHealthOptionsSelection",
                type: "GET",
                data: {
                    Name: bhFoodCheckSelector.name,
                    FoodCheckSelectorId: $("#documentId").val(),
                    Year: bhFoodCheckSelector.year,
                    Month: bhFoodCheckSelector.month,
                    Weight: bhFoodCheckSelector.weight
                },
                dataType: "html",
                success: function (data) {
                    if(!data.includes('protein-preferences-section')){
                        $(".selected-form").html(data);
                        changeQuizBottomPanel(pages.healthOptions);
                        initializeHealthOptionsPage();
                    }else{
                        if(isBack){
                            getWeightSelectionPage();
                        }else{
                            $(".selected-form").html(data);
                            changeQuizBottomPanel(pages.proteinPreferences);
                            initializeProteinPreferencesPage();
                        }
                    }
                },
                error: function (xhr, status, error) {
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                }
            });
        }

        function initializeBreadCrumbs() {
            $(`.${currentPage}`).addClass('is-active');
        }

        function initializeHealthOptionsPage() {
            if(bhFoodCheckSelector.healthOption !== 0) {
                $(`#${bhFoodCheckSelector.healthOption}`).closest('.quiz-question').addClass('is-complete');
            }
        }

        function initializeProteinPreferencesPage() {
            if(bhFoodCheckSelector.proteinPreference !== 0) {
                $(`#${bhFoodCheckSelector.proteinPreference}`).closest('.quiz-question').addClass('is-complete');
            }
        }

        $(document).on("click",'.quiz-question__link', function() {
            const allQuizQuestions = $(".quiz-question");
            allQuizQuestions.each(function() {
                $(this).removeClass('is-complete')
            });

            //add class
            $(this).closest('.quiz-question').addClass('is-complete');

            switch(currentPage){
                case pages.healthOptions:
                    bhFoodCheckSelector.healthOption = +$(this).closest('.quiz-question').find('.quiz-question__link').attr('id');
                    break;
                case pages.proteinPreferences:
                    bhFoodCheckSelector.proteinPreference = +$(this).closest('.quiz-question').find('.quiz-question__link').attr('id');
                    break;
            }
        });

        function changeQuizBottomPanel(selectedPage){
            currentPage = selectedPage;
            const bottomPanel = $(".quiz__bottom-panel");
            const quizProgress = $(".quiz-progress");
            const quizBottomPanelGetResult = $(".quiz__bottom-panel-results");

            switch(currentPage){
                case pages.ageSelection:
                    bottomPanel.hide();
                    quizProgress.hide();
                    footer.hide();
                    breadcrumbs.hide();
                    quizBottomPanelGetResult?.hide();
                    break;
                case pages.weightSelection:
                case pages.healthOptions:
                    bottomPanel.show();
                    quizProgress.show();
                    footer.hide();
                    breadcrumbs.hide();
                    quizBottomPanelGetResult?.hide();
                    break;
                case pages.proteinPreferences:
                    bottomPanel.hide();
                    quizProgress.show()
                    footer.hide();
                    breadcrumbs.hide();
                    quizBottomPanelGetResult?.show();
                    break;
                case pages.results:
                    bottomPanel.hide();
                    quizProgress.hide()
                    quizBottomPanelGetResult?.show();
                    footer.show();
                    breadcrumbs.show();
                    break;
            }

            const healthOptionNextHandler = function() {
                $('#next-button').removeAttr("disabled");
            };
            if(currentPage === pages.healthOptions)
            {
                $(".js-health-option--link").on("click", healthOptionNextHandler);
                $('#next-button').attr("disabled", "disabled");
            }else{
                $('#next-button').removeAttr("disabled");
                $(".js-health-option--link").off("click", healthOptionNextHandler);
            }

            initializeBreadCrumbs();
        }
        function formIsValid(){
            const submitBtn = $("#age-selection-submit");
            bhFoodCheckSelector.name = $('#pet-name').val();
            bhFoodCheckSelector.year = +$('#pet-year').val();
            bhFoodCheckSelector.month = +$('#pet-month').val();

            if(bhFoodCheckSelector.name === '' || (bhFoodCheckSelector.year === 0 && bhFoodCheckSelector.month === 0))
            {
                submitBtn.prop("disabled", true);
                return false;
            }

            submitBtn.prop("disabled", false);
            return true;
        }

        function initializeWeightSlider(){
            initializeJsToolTip();
            const index = foodcheckSliderAmountMap.indexOf( bhFoodCheckSelector.weight);
            $(".js-foodcheck-weight-slider").slider({
                value: index,
                min: 0,
                max: foodcheckSliderAmountMap.length-1, //the maximum value the slider will extend
                slide: function( event, ui ) {

                    bhFoodCheckSelector.weight = foodcheckSliderAmountMap[ui.value];
                }
            });
        }

        function initializeJsToolTip(){
            $('.js-tooltip').tooltip({
                tooltipClass: "tooltip",
                content: function () {
                    return $(this).attr('title');
                },
                close: function (event, ui) {
                    //keep tooltip open on tooltip hover
                    ui.tooltip.hover(function () {
                            $(this).stop(true).fadeTo(400, 1);
                        },
                        function () {
                            $(this).fadeOut('400', function () {
                                $(this).remove();
                            });
                        });
                }
            });
        }

        function scrollToTop() {
            $('html, body').animate({
                scrollTop: $("main").offset().top
            }, 400);
        }

        $(document).on("click", ".js-foodcheck-weight-slider-buttons button", function (e) {
            e.preventDefault();
            const value = $(this).data("value");
            $(".js-foodcheck-weight-slider").slider( "value", value );
            bhFoodCheckSelector.weight = foodcheckSliderAmountMap[value];
        });

        $(document).on("change", ".pet-age-form", function (e) {
            e.preventDefault();
            formIsValid();
        });

        $(document).on("click", "#js-previous-button", function(e) {

            e.preventDefault();

            switch(currentPage){
                case pages.weightSelection:
                    getAgeSelectionPage();
                    break;
                case pages.healthOptions:
                    getWeightSelectionPage();
                    break;
                case pages.proteinPreferences:
                    getHealthOptionsPage(true);
                    break;
                case pages.results:
                    getProteinPreferencesPage();
                    break;
            }

            $(`.${currentPage}`).removeClass('is-active');

            scrollToTop();
        });

        $(document).on("click", "#next-button", function(e) {
            e.preventDefault();

            switch(currentPage){
                case pages.weightSelection:
                    getHealthOptionsPage();
                    break;
                case pages.healthOptions:
                    getProteinPreferencesPage();
                    break;
            }

            scrollToTop();
        });

        $(document).on("click", "#js-start-over-button", function(e){
            e.preventDefault();
            window.location.reload();
        });

        $(document).on("click", "#get-results", function(e) {
            e.preventDefault();

            getResultsPage();
            scrollToTop();
        });

        $(document).on("click", "#age-selection-submit", function (e) {
            e.preventDefault();

            if (formIsValid())
            {
                getWeightSelectionPage();
            }
            scrollToTop();
        });
    });

})(foodCheck);
